import { GridColDef } from '@mui/x-data-grid';

export const getInputTableColumns = (): GridColDef[] => [
  {
    field: 'stt',
    headerName: 'STT',
    width: 60,
    align: 'center',
    cellClassName: params => (params.row.bold_yn === '1' ? 'font-bold' : '')
  },
  {
    field: 'ma_so',
    headerName: 'Mã chỉ tiêu',
    width: 100,
    cellClassName: params => (params.row.bold_yn === '1' ? 'font-bold' : '')
  },
  {
    field: 'chi_tieu',
    headerName: 'Chỉ tiêu',
    width: 300,
    cellClassName: params => (params.row.bold_yn === '1' ? 'font-bold' : '')
  },
  {
    field: 'tk',
    headerName: 'Tài khoản',
    width: 150,
    cellClassName: params => (params.row.bold_yn === '1' ? 'font-bold' : ''),
    renderCell: params => <span>{params.value?.join(', ')}</span>
  },
  {
    field: 'tk_du',
    headerName: 'Tài khoản đối ứng',
    width: 200,
    cellClassName: params => (params.row.bold_yn === '1' ? 'font-bold' : ''),
    renderCell: params => <span>{params.value?.join(', ')}</span>
  },
  {
    field: 'cong_no',
    headerName: 'Công nợ',
    width: 100,
    cellClassName: params => (params.row.bold_yn === '1' ? 'font-bold' : ''),
    type: 'number'
  },
  {
    field: 'cong_thuc',
    headerName: 'Công thức',
    width: 200,
    cellClassName: params => (params.row.bold_yn === '1' ? 'font-bold' : '')
  }
];
